import React, { useState } from 'react';
import { Button, TextField, Typography, Grid, useMediaQuery, useTheme, InputAdornment } from '@mui/material';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
 
function UpdateProfile() {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
 
  const handleUpdate = async (event) => {
    event.preventDefault();
 
    if (email === '' || username === '' || password === '' || confirmPassword === '') {
      setErrorMessage('Por favor, preencha todos os campos.');
      return;
    }
 
    if (password !== confirmPassword) {
      setErrorMessage('As senhas não coincidem.');
      return;
    }
 
    setErrorMessage('');
    setLoading(true);
 
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/user-email/${email}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: username,
          password
        }),
      });
 
      const data = await response.json();
 
      if (response.ok) {
        console.log('Perfil atualizado com sucesso:', data);
        navigate('/'); // Redireciona para a página inicial
      } else {
        setErrorMessage(data.error || 'Falha ao atualizar o perfil.');
      }
    } catch (error) {
      console.error('Erro ao atualizar perfil:', error);
      setErrorMessage('Erro no servidor. Por favor, tente novamente mais tarde.');
    }
 
    setLoading(false);
  };
 
  return (
<Grid container className="container" style={{ height: '100vh' }}>
      {/* Seção da esquerda */}
<Grid
        item
        xs={12}
        sm={6}
        className="left-section"
        style={{
          backgroundColor: '#f5f8fc',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          textAlign: 'center',
        }}
>
<Typography variant="h4" gutterBottom>
          Update Your Profile!
</Typography>
<Typography variant="h6" gutterBottom>
          Hub4Food<sup>®</sup>
</Typography>
 
        <div className="left-section-footer">
<Typography variant="body2">
            Comeback To{' '}
<Link to="/" style={{ color: '#007bff', textDecoration: 'none' }}>
              Login
</Link>
</Typography>
</div>
</Grid>
 
      {/* Seção da direita */}
<Grid
        item
        xs={12}
        sm={6}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px',
        }}
>
<img
          src="/logotipo.png"
          alt="Hub4Food Logo"
          className="logo"
          style={{ width: isMobile ? '60px' : '80px', marginBottom: '20px' }}
        />
<Typography variant="h5" gutterBottom>
          Update Your Data
</Typography>
<form id="update-form" onSubmit={handleUpdate} style={{ width: '100%', maxWidth: '300px' }}>
<TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            margin="normal"
            placeholder="Type Your Email"
            InputProps={{
              startAdornment: (
<InputAdornment position="start">
<AccountBoxIcon />
</InputAdornment>
              ),
            }}
          />
<TextField
            label="Username"
            variant="outlined"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            margin="normal"
            placeholder="Type Your Username"
            InputProps={{
              startAdornment: (
<InputAdornment position="start">
<AccountBoxIcon />
</InputAdornment>
              ),
            }}
          />
<TextField
            label="New Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            margin="normal"
            placeholder="Type Your New Password"
            InputProps={{
              startAdornment: (
<InputAdornment position="start">
<LockOpenIcon />
</InputAdornment>
              ),
            }}
          />
<TextField
            label="Confirm Password"
            type="password"
            variant="outlined"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            margin="normal"
            placeholder="Confirm Your New Password"
            InputProps={{
              startAdornment: (
<InputAdornment position="start">
<LockOpenIcon />
</InputAdornment>
              ),
            }}
          />
<Button
            type="submit"
            variant="contained"
            color="primary"
            className="update-button"
            style={{
              width: '100%',
              marginTop: '10px',
              padding: '10px',
              fontSize: '16px',
            }}
            disabled={loading}
>
            {loading ? 'Registering...' : 'Register'}
</Button>
</form>
 
        {errorMessage && (
<Typography color="error" className="error-message" style={{ marginTop: '10px', textAlign: 'center' }}>
            {errorMessage}
</Typography>
        )}
</Grid>
</Grid>
  );
}
 
export default UpdateProfile;